<app-card cardTitle="{{ 'changePassword' | translate }}">
  <ng-template #headerOptionsTemplate>
    <a href="javascript:" class="text-muted" mat-dialog-close>
      <i class="ti ti-x f-20"></i>
    </a>
  </ng-template>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <label for="last name" class="f-w-500">{{ 'oldPassword' | translate }}</label>
        <mat-form-field appearance="outline" class="w-100 m-t-5">
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="currentPassword" />
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>

          <mat-error>
            <span
              class="text-danger"
              *ngIf="
                (formControl['currentPassword'].touched || submitted) &&
                formControl['currentPassword'].errors &&
                formControl['currentPassword'].errors['required']
              "
            >
              {{ 'requiredMessage' | translate }}
            </span>
          </mat-error>
        </mat-form-field>

        <div class="m-b-15">
          <label for="last name" class="f-w-500">{{ 'newPassword' | translate }}</label>
          <mat-form-field appearance="outline" class="w-100 m-t-5">
            <input matInput [type]="newHide ? 'password' : 'text'" formControlName="newPassword" />
            <button mat-icon-button matSuffix (click)="newHide = !newHide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{ newHide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>

            <mat-error>
              <span
                class="text-danger"
                *ngIf="
                  (formControl['newPassword'].touched || submitted) &&
                  formControl['newPassword'].errors &&
                  formControl['newPassword'].errors['required']
                "
              >
                {{ 'requiredMessage' | translate }}
              </span>
              <span
                class="text-danger"
                *ngIf="
                  formControl['newPassword'].touched &&
                  formControl['newPassword'].errors &&
                  formControl['newPassword'].errors['invalidPassword']
                "
              >
                {{ 'passwordValidationMessage' | translate }}
              </span>
              <span
              class="text-danger"
              *ngIf="
                formControl['newPassword'].touched &&
                formControl['newPassword'].errors &&
                formControl['newPassword'].errors['sameAsOldPassword']
              "
            >
              {{ 'newPasswordSameAsOldMessage' | translate }}
            </span>
            </mat-error>
          </mat-form-field>
        </div>
        <label for="last name" class="f-w-500">{{ 'confirmPassword' | translate }}</label>
        <mat-form-field appearance="outline" class="w-100 m-t-5">
          <input matInput [type]="conHide ? 'password' : 'text'" formControlName="confirmPassword" />
          <button mat-icon-button matSuffix (click)="conHide = !conHide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{ conHide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>
            <span
              class="text-danger"
              *ngIf="
                (formControl['confirmPassword'].touched || submitted) &&
                formControl['confirmPassword'].errors &&
                formControl['confirmPassword'].errors['required']
              "
            >
              {{ 'requiredMessage' | translate }}
            </span>

            <span
              class="text-danger"
              *ngIf="
                formControl['confirmPassword'].touched &&
                formControl['confirmPassword'].errors &&
                formControl['confirmPassword'].errors['passwordMismatch']
              "
            >
              {{ 'passwordNotMatch' | translate }}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <div class="f-w-500">{{ 'NewPasswordMustContain' | translate }}</div>
        <ul class="list-group list-group-flush">
          @for (task of password_type; track task) {
            <li class="list-group-item">
              <i class="ti ti-circle-check text-success-500 f-16 m-r-10"></i>
              {{ task.title | translate }}
            </li>
          }
        </ul>
      </div>

      <div class="file-footer">
        <div class="text-end">
          <button mat-stroked-button class="m-r-10" mat-dialog-close>{{ 'cancel' | translate }}</button>
          <button mat-flat-button color="primary" class="m-r-10" (click)="onSubmit()">{{ 'change' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
</app-card>
